import React, { useEffect, useState } from "react";
import {
  useGetCompleteOnboardWorkshopDataQuery,
  useGetGeoLocationMutation,
  useGetOnboardWorkshopDataQuery,
  useUpdateWorkshopMutation,
} from "../../../Services/vehicle/Vehicle";
import useThemeColors from "../ThemeColors";
import "./WorkshopTable.scss";
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { Loader } from "react-bootstrap-typeahead";

const WorkshopEdit = () => {
  const [workshopInfoData, setWorkshopData] = useState<any>({});
  const [nameValue, setNameValue] = useState("");
  const [addressValue, setAddressValue] = useState("");
  const [cityValue, setCityValue] = useState("");
  const [stateValue, setStateValue] = useState("");
  const [countryValue, setCountryValue] = useState("");
  const [pincodeValue, setPincodeValue] = useState("");
  const [startTimeValue, setStartTimeValue] = useState("");
  const [adminNameValue, setAdminNameValue] = useState("");
  const [adminUsernameValue, setAdminUsernameValue] = useState("");
  const [endTimeValue, setEndTimeValue] = useState("");
  const [adminEmailValue, setAdminEmailValue] = useState("");
  const [adminPhoneValue, setAdminPhoneValue] = useState("");
  const [escalationPhoneValue, setEscalationPhoneValue] = useState("");
  const [storedWorkshopData, setStoreWorkshopData] = useState([]);
  const [image, setImage] = useState<any>("");
  const [gstNumber, setGstNumber] = useState("");
  const [selectedHolidays, setSelectedHolidays] = useState<any>([]);
  const [ischangeImageButtonClicked, setIsChangeImageButtonClicked] =
    useState(false);
  const [storeGeoLocationData, setStoreGeoLocationData] = useState<any>("");
  const [geoLoctionLoader, setGeoLocationLoader] = useState(false);
  const [updateWorkshopLoader, setUpdateWorkshopLoader] = useState(false);

  // New Error states
  const [adminPhoneError, setAdminPhoneError] = useState(false);
  const [escalationPhoneError, setEscalationPhoneError] = useState(false);

  const [geoLocationTrigger, { status }] = useGetGeoLocationMutation();

  useEffect(() => {
    if (workshopInfoData?.holiday) {
      const holidaysArray = workshopInfoData.holiday
        .split(",")
        .map((day) => day.trim());
      setSelectedHolidays(holidaysArray);
    }
  }, [workshopInfoData]);

  useEffect(() => {
    if (workshopInfoData) {
      setNameValue(workshopInfoData?.workshopName);
      setAddressValue(workshopInfoData?.address);
      setCityValue(workshopInfoData?.city);
      setStateValue(workshopInfoData?.state);
      setCountryValue(workshopInfoData?.country);
      setPincodeValue(workshopInfoData?.pincode);
      setStartTimeValue(workshopInfoData?.startTime);
      setEndTimeValue(workshopInfoData?.endTime);
      setAdminNameValue(workshopInfoData?.workShopAdministrationName);
      setAdminUsernameValue(workshopInfoData?.workShopAdministrationUserName);
      setAdminEmailValue(workshopInfoData?.workShopAdministrationEmail);
      setAdminPhoneValue(workshopInfoData?.workShopAdministrationPhoneNumber);
      setEscalationPhoneValue(workshopInfoData?.EscalationNumber);
      setImage(workshopInfoData?.workshopImage);
      setGstNumber(workshopInfoData?.gstNumber);
    }
  }, [workshopInfoData]);

  useEffect(() => {
    if (status === "pending") {
      setGeoLocationLoader(true);
    } else {
      setGeoLocationLoader(false);
    }
  }, [status]);

  console.log(image, "image");

  const location = useLocation();
  const pathSegments = location?.pathname.split("/");

  const workshopIndex = pathSegments.indexOf("workshop-edit");

  // Get the next segment (the number) after "workshop-edit"
  const workshopId =
    workshopIndex !== -1 ? pathSegments[workshopIndex + 1] : null;

  const { data: wokshopInfo } =
    useGetCompleteOnboardWorkshopDataQuery(workshopId);

  const [updateWorkshopTrigger, { status: updateWOrkshopStatus }] =
    useUpdateWorkshopMutation();

  useEffect(() => {
    if (updateWOrkshopStatus === "pending") {
      setUpdateWorkshopLoader(true);
    } else {
      setUpdateWorkshopLoader(false);
    }
  }, [updateWOrkshopStatus]);

  useEffect(() => {
    if (wokshopInfo) {
      setWorkshopData(wokshopInfo);
    }
  }, [wokshopInfo]);

  const { data: workshopData } = useGetOnboardWorkshopDataQuery({});

  const holidaysList = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  useEffect(() => {
    if (workshopData) {
      setStoreWorkshopData(workshopData?.results);
    }
  }, [workshopData]);

  const imageHandler = (e) => {
    setIsChangeImageButtonClicked(true);
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    setSelectedHolidays(typeof value === "string" ? value.split(",") : value);
  };

  // Helper function to allow only digits and max 10 length
  const handleMobileNumberChange = (value, setter, errorSetter) => {
    const numericValue = value.replace(/\D/g, ""); // Remove non-digits
    if (numericValue.length <= 10) {
      setter(numericValue);
      if (numericValue.length > 0) {
        errorSetter(false); // clear error on valid typing
      }
    }
  };

  // Validation helper for exactly 10 digits
const validateMobileNumber = (number) => {
  const strNumber = String(number); // Convert to string safely
  const trimmed = strNumber.trim(); // Now safe to trim
  return trimmed.length === 10 && /^\d{10}$/.test(trimmed);
};


  const onboardWorkshophandler = async () => {
    // Validate mobile numbers
    let hasError = false;
    if (!validateMobileNumber(adminPhoneValue)) {
      setAdminPhoneError(true);
      hasError = true;
    }
    if (!validateMobileNumber(escalationPhoneValue)) {
      setEscalationPhoneError(true);
      hasError = true;
    }
    if (hasError) {
      toast.error("Please enter valid 10-digit mobile numbers");
      return;
    }

    const formData = new FormData();

    // Helper to append only changed values
    const appendIfChanged = (key: string, value: any) => {
      if (
        value !== workshopInfoData?.[key] &&
        value !== undefined &&
        value !== null
      ) {
        formData.append(key, value);
      }
    };

    appendIfChanged("workshopName", nameValue);
    appendIfChanged("address", addressValue);
    appendIfChanged("city", cityValue);
    appendIfChanged("state", stateValue);
    appendIfChanged("country", countryValue);
    appendIfChanged("pincode", pincodeValue);
    appendIfChanged("startTime", startTimeValue);
    appendIfChanged("endTime", endTimeValue);
    appendIfChanged("workShopAdministrationName", adminNameValue);
    appendIfChanged("workShopAdministrationUserName", adminUsernameValue);
    appendIfChanged("workShopAdministrationEmail", adminEmailValue);
    appendIfChanged("workShopAdministrationPhoneNumber", adminPhoneValue);
    appendIfChanged("EscalationNumber", escalationPhoneValue);
    appendIfChanged("gstNumber", gstNumber);

    // Handle holidays comparison (convert to comma-separated string)
    const holidaysString = selectedHolidays.join(",");
    if (holidaysString !== workshopInfoData?.holiday) {
      formData.append("holiday", holidaysString);
    }

    // Handle image upload separately
    if (ischangeImageButtonClicked && image) {
      formData.append("workshopImage", image);
    }

    // ✅ If no changes detected, show warning & stop API call
    if (Array.from(formData.keys()).length === 0) {
      toast.info("No changes detected");
      return;
    }

    const response = await updateWorkshopTrigger({
      id: workshopId,
      body: formData,
    });

    try {
      if (response?.data) {
        toast.success("Fields edited successfully");
      } else if ("data" in response?.error) {
        const errorData = response.error.data as Record<string, string[]>;

        const phoneError = errorData["workShopAdministrationPhoneNumber"]?.[0];
        const escalationError = errorData["EscalationNumber"]?.[0];
        const escalationEmail = errorData["workShopAdministrationEmail"]?.[0];
        const workshopImage = errorData["workshopImage"]?.[0];

        if (phoneError) toast.error(phoneError);
        if (escalationError) toast.error(escalationError);
        if (escalationEmail) toast.error(escalationEmail);
        if (workshopImage) toast.error(workshopImage);
      }
    } catch (error) {
      toast.error("An error occurred while onboarding the workshop");
    }
  };

  const getLocation = async (e: any) => {
    e.preventDefault();
    const locationPayload = {
      address: addressValue,
    };
    try {
      const response = await geoLocationTrigger(locationPayload);

      setStoreGeoLocationData(response?.data);
      if (response?.data) {
        toast.success("Location fetched successfully");
      } else if (response?.error) {
        toast.error("unable to find the location");
      }
    } catch (error) {}
  };

  return (
    <div
      className="edit-workshop-cont"
      style={{
        background: "white",
        height: "80%",
        boxShadow: `${selectedColor}80 0px 2px 10px 2px`,
        borderRadius: "40px",
      }}
    >
      <div
        className="edit-workshop-heading"
        style={{
          borderBottom: "1px solid #bfbfbf",
          padding: "15px 25px",
          paddingBottom: "5px",
          color: "#626262",
          marginBottom: "20px",
        }}
      >
        Edit Workshop
      </div>
      <div
        className="edit-workshop-sub-heading"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          height: "100%",
          padding: "10px 20px",
        }}
      >
        <div
          className="edit-workshop-label"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: "5px",
          }}
        >
          <label
            className="required"
            style={{
              color: "#626262",
              padding: "0 10px",
            }}
          >
            Name of the Workshop
          </label>
          <input
            placeholder="Workshop name..."
            value={nameValue}
            onChange={(e) => setNameValue(e.target.value)}
            style={{
              borderRadius: "24px",
              padding: "10px",
              border: "0.5px solid #BFBFBF",
              background: "rgb(248, 233, 227)",
            }}
          />
        </div>
        {/* Address */}
        <div style={{ display: "flex", gap: "10px" }}>
          <div
            className="edit-workshop-label"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                color: "#626262",
                padding: "0 10px",
              }}
            >
              Address
            </label>
            <input
              placeholder="Address..."
              value={addressValue}
              onChange={(e) => setAddressValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
          </div>
          <div className="edit-workshop-label" style={{ paddingTop: "30px" }}>
            <button
              style={{
                padding: "8px 25px",
                borderRadius: "20px",
                background: `${selectedButtonBackgoundColors}`,
                color: `${selectedButtonColors}`,
                border: `1px solid ${selectedBorderColor}`,
                whiteSpace: "nowrap",
              }}
              type="button"
              onClick={getLocation}
            >
              {geoLoctionLoader ? <Loader /> : "Get location"}
            </button>
          </div>
        </div>
        {/* Codes */}
        <div
          style={{
            display: "flex",
            gap: "20px",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            className="edit-workshop-label"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                color: "#626262",
                padding: "0 10px",
              }}
            >
              City
            </label>
            <input
              placeholder="City..."
              value={cityValue}
              onChange={(e) => setCityValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
          </div>
          <div
            className="edit-workshop-label"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                color: "#626262",
                padding: "0 10px",
              }}
            >
              State
            </label>
            <input
              placeholder="State..."
              value={stateValue}
              onChange={(e) => setStateValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
          </div>
          <div
            className="edit-workshop-label"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                color: "#626262",
                padding: "0 10px",
              }}
            >
              PIN Code
            </label>
            <input
              placeholder="PIN code..."
              value={pincodeValue}
              onChange={(e) => setPincodeValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
          </div>
          <div
            className="edit-workshop-label"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              style={{
                color: "#626262",
                padding: "0 10px",
              }}
            >
              Country
            </label>
            <input
              placeholder="Country..."
              value={countryValue}
              onChange={(e) => setCountryValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div
            className="edit-workshop-label"
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <label>GST Number</label>
            <input
              value={gstNumber}
              onChange={(e) => setGstNumber(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
          </div>

          <FormControl fullWidth>
            <label style={{ fontFamily: "Karbon" }}>Holidays</label>
            <Select
              multiple
              value={selectedHolidays}
              onChange={handleChange}
              input={<OutlinedInput />}
              renderValue={(selected) => selected.join(", ")}
              style={{ height: "45px" }}
            >
              {holidaysList.map((day) => (
                <MenuItem key={day} value={day}>
                  <Checkbox checked={selectedHolidays.includes(day)} />
                  <ListItemText primary={day} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* Working hours start */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <div className="edit-workshop-label">
            <label
              className="required"
              style={{
                color: "#626262",
                padding: "0 10px",
                fontWeight: "600",
              }}
            >
              Working Hours
            </label>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="edit-workshop-label"
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: "10px",
              }}
            >
              <label
                className="required"
                style={{
                  color: "#626262",
                  padding: "0 5px",
                }}
              >
                Start Time
              </label>
              <input
                type="time"
                value={startTimeValue}
                onChange={(e) => setStartTimeValue(e.target.value)}
                style={{
                  borderRadius: "24px",
                  padding: "10px",
                  border: "0.5px solid #BFBFBF",
                  background: "rgb(248, 233, 227)",
                }}
              />
            </div>
            <div
              className="edit-workshop-label"
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: "5px",
              }}
            >
              <label
                className="required"
                style={{
                  color: "#626262",
                  padding: "0 10px",
                }}
              >
                End Time
              </label>
              <input
                type="time"
                value={endTimeValue}
                onChange={(e) => setEndTimeValue(e.target.value)}
                style={{
                  borderRadius: "24px",
                  padding: "10px",
                  border: "0.5px solid #BFBFBF",
                  background: "rgb(248, 233, 227)",
                }}
              />
            </div>
          </div>
        </div>
        {/* Working hours end */}

        {/* Workshop image */}
        <div
          className="edit-workshop-label"
          style={{
            display: "flex",
            width: "100%",
            gap: "20px",
            flexDirection: "column",
          }}
        >
          <label
            className="required"
            style={{
              color: "#626262",
              padding: "0 10px",
            }}
          >
            Workshop Image
          </label>
          <div
            className="edit-workshop-label"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <div
              style={{
                width: "200px",
              }}
            >
              {image && (
                <img
                  src={
                    typeof image === "string"
                      ? image
                      : URL.createObjectURL(image)
                  }
                  alt="preview"
                  width={200}
                  height={200}
                />
              )}
            </div>
            <label
              htmlFor="upload-logo"
              style={{
                padding: "8px 12px",
                backgroundColor: "#007bff",
                borderRadius: "5px",
                cursor: "pointer",
                border: `1px solid ${selectedBorderColor}`,
                background: `${selectedButtonBackgoundColors}`,
                width: "150px",
                color: `${selectedButtonColors}`,
                display: "flex",
                justifyContent: "center",
              }}
            >
              {ischangeImageButtonClicked ? " Upload Image" : "Change Image"}
            </label>

            <span
              style={{
                color: "#666",
                fontFamily: "karbon-semi",
              }}
            >
              Accepted formats: JPG, PNG, WEBP
            </span>
          </div>

          {!ischangeImageButtonClicked && (
            <input
              type="file"
              id="upload-logo"
              style={{ display: "none" }}
              accept=".jpg,.jpeg,.png,.webp"
              onChange={imageHandler}
            />
          )}
        </div>
        {/* Workshop image ends */}
        <div style={{ display: "flex", gap: "20px", width: "100%" }}>
          <div
            className="edit-workshop-label"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
              }}
            >
              Workshop Administrator Name
            </label>
            <input
              placeholder="Workshop administration name..."
              value={adminNameValue}
              onChange={(e) => setAdminNameValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
          </div>
          <div
            className="edit-workshop-label"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
              }}
            >
              Workshop Administrator Username
            </label>
            <input
              placeholder="Workshop administrator username"
              value={adminUsernameValue}
              onChange={(e) => setAdminUsernameValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
          </div>
        </div>
        <div style={{ display: "flex", gap: "20px", width: "100%" }}>
          <div
            className="edit-workshop-label"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
              }}
            >
              Administrator Email
            </label>
            <input
              placeholder="Administrator email..."
              value={adminEmailValue}
              onChange={(e) => setAdminEmailValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
          </div>
          <div
            className="edit-workshop-label"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
              }}
            >
              Mobile Number
            </label>
            <input
              placeholder="Mobile number..."
              value={adminPhoneValue}
              onChange={(e) =>
                handleMobileNumberChange(
                  e.target.value,
                  setAdminPhoneValue,
                  setAdminPhoneError
                )
              }
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
            {adminPhoneError && (
              <span
                style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}
              >
                {adminPhoneValue.length === 0
                  ? "Mobile number is required"
                  : "Mobile number must be exactly 10 digits"}
              </span>
            )}
          </div>
          <div
            className="edit-workshop-label"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
              }}
            >
              Escalation Mobile Number
            </label>
            <input
              placeholder="Escalation mobile number"
              value={escalationPhoneValue}
              onChange={(e) =>
                handleMobileNumberChange(
                  e.target.value,
                  setEscalationPhoneValue,
                  setEscalationPhoneError
                )
              }
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
            {escalationPhoneError && (
              <span
                style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}
              >
                {escalationPhoneValue.length === 0
                  ? "Escalation number is required"
                  : "Escalation number must be exactly 10 digits"}
              </span>
            )}
          </div>
        </div>

        <div
          className="edit-workshop-label"
          style={{
            display: "flex",
            justifyContent: "end",
            gap: "10px",
          }}
        >
          <button
            className="btn btn-secondary"
            style={{ borderRadius: "20px" }}
          >
            Cancel
          </button>
          <button
            style={{
              padding: "10px 25px",
              borderRadius: "20px",
              background: `${selectedButtonBackgoundColors}`,
              color: `${selectedButtonColors}`,
              border: `1px solid ${selectedBorderColor}`,
            }}
            onClick={onboardWorkshophandler}
          >
            {updateWorkshopLoader ? (
              <>
                Saving...
                <Loader />
              </>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>

      <div>
        <iframe
          width="100%"
          height="300"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          src={`https://www.google.com/maps?q=${
            storeGeoLocationData
              ? storeGeoLocationData?.latitude
              : workshopInfoData?.latitude
          },${
            storeGeoLocationData
              ? storeGeoLocationData?.longitude
              : workshopInfoData?.longitude
          }&z=15&output=embed`}
        />
      </div>
    </div>
  );
};

export default WorkshopEdit;
